"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachPlatform = function SvgBeachPlatform(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.878 7.222H2.671A1.171 1.171 0 0 1 1.5 6.05V3.726a1.171 1.171 0 0 1 1.17-1.17h18.66a1.171 1.171 0 0 1 1.17 1.17V6.05a1.172 1.172 0 0 1-1.17 1.17h-1.131a.602.602 0 0 0-.602.603v2.225a.601.601 0 0 1-.437.578c-.38.109-.729.303-1.022.568a1.298 1.298 0 0 1-1.764.012 2.588 2.588 0 0 0-1.016-.575.6.6 0 0 1-.428-.576V7.824a.603.603 0 0 0-.602-.602h-4.58a.602.602 0 0 0-.601.602v2.21a.598.598 0 0 1-.441.58 2.591 2.591 0 0 0-1.081.592 1.298 1.298 0 0 1-1.767-.013 2.586 2.586 0 0 0-.955-.547.602.602 0 0 1-.423-.575V7.824a.603.603 0 0 0-.603-.602Zm16.405 4.826c.476.436 1.07.722 1.707.822a.602.602 0 0 1 .51.593v6.607a1.171 1.171 0 0 1-1.17 1.17H2.67a1.171 1.171 0 0 1-1.17-1.17v-6.607a.602.602 0 0 1 .511-.593 3.27 3.27 0 0 0 1.706-.822.605.605 0 0 1 .816 0 3.28 3.28 0 0 0 4.434 0 .605.605 0 0 1 .816 0 3.281 3.281 0 0 0 4.434 0 .605.605 0 0 1 .816 0 3.281 3.281 0 0 0 4.434 0 .605.605 0 0 1 .816 0Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachPlatform);
var _default = exports["default"] = Memo;